<template>
  <div>
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
    <signatures v-if="showSignature"
      :signaturesList="photoType"
      v-on:closesignature="closeSignature">
    </signatures>
    <div class="card-body">
      <div class="card-title text-center">
        <h3>Digital Header troubleshooting</h3>
      </div>
      <form @submit.prevent>
        <div class="form-group">
          <label for="">Take a picture</label>
          <div>
            <a v-on:click='takePicture(["DigitalHeaderTroubleshoot", "pictures"])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
            <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i> {{DigitalHeaderTroubleshoot.pictures.length}}</badge>
            <div v-if="showErrorPictures"><span class="errorimagesquantity">Picture is required</span></div>
          </div>
        </div>

        <div class="form-group">
          <label for="isScreenWorking">Is the screen working?</label>
          <select class="form-control" name="isScreenWorking" id="isScreenWorking" v-model="DigitalHeaderTroubleshoot.isScreenWorking" v-validate="'required'" data-vv-validate-on="blur">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
          <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('isScreenWorking') }}</span>
          </div>
        </div>

        <div>
          <h6>Power</h6>

          <div class="form-group">
            <label for="isSurgeProtector">Is there a surge protector?</label>
            <select class="form-control" name="isSurgeProtector" id="isSurgeProtector" v-model="DigitalHeaderTroubleshoot.isSurgeProtector" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('isSurgeProtector') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="surgeProtectorPlugged">Surge protector is properly plugged into the wall outlet</label>
            <select class="form-control" name="surgeProtectorPlugged" id="surgeProtectorPlugged" v-model="DigitalHeaderTroubleshoot.surgeProtectorPlugged" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('surgeProtectorPlugged') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="surgeProtectorSwitchLit">Surge protector switch is lit up and on</label>
            <select class="form-control" name="surgeProtectorSwitchLit" id="surgeProtectorSwitchLit" v-model="DigitalHeaderTroubleshoot.surgeProtectorSwitchLit" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('surgeProtectorSwitchLit') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="cordsConnected">All power cords are tightly connected</label>
            <select class="form-control" name="cordsConnected" id="cordsConnected" v-model="DigitalHeaderTroubleshoot.cordsConnected" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('cordsConnected') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="routerScreenPlugged">Both router and screen are plugged into surge protector</label>
            <select class="form-control" name="routerScreenPlugged" id="routerScreenPlugged" v-model="DigitalHeaderTroubleshoot.routerScreenPlugged" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('routerScreenPlugged') }}</span>
            </div>
          </div>

          <h6>Router</h6>

          <div class="form-group">
            <label for="ethernetCordConnected">Ethernet cord is connected to LAN 1 (Not WAN)</label>
            <select class="form-control" name="ethernetCordConnected" id="ethernetCordConnected" v-model="DigitalHeaderTroubleshoot.ethernetCordConnected" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('ethernetCordConnected') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="greenPlugConnected">Green plug is connected to the router</label>
            <select class="form-control" name="greenPlugConnected" id="greenPlugConnected" v-model="DigitalHeaderTroubleshoot.greenPlugConnected" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('greenPlugConnected') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="routerConnected">Router is connected to surge protector</label>
            <select class="form-control" name="routerConnected" id="routerConnected" v-model="DigitalHeaderTroubleshoot.routerConnected" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('routerConnected') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="lightsSolid">All lights are solid and not blinking</label>
            <select class="form-control" name="lightsSolid" id="lightsSolid" v-model="DigitalHeaderTroubleshoot.lightsSolid" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('lightsSolid') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="antennasTight">Routers antennas are tight</label>
            <select class="form-control" name="antennasTight" id="antennasTight" v-model="DigitalHeaderTroubleshoot.antennasTight" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('antennasTight') }}</span>
            </div>
          </div>

          <h6>Signal strength</h6>

          <div class="form-group">
            <label for="barsTablet">How many bars are appearing on your tablets screen location?</label>
            <input class="form-control" type="number" min="0" name="barsTablet" id="barsTablet" v-model="DigitalHeaderTroubleshoot.barsTablet" v-validate="'required'" data-vv-validate-on="blur">
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('barsTablet') }}</span>
            </div>
          </div>

          <h6>Screen</h6>

          <div class="form-group">
            <label for="ethernetCablePlugged">Ethernet cable is plugged into the screen</label>
            <select class="form-control" name="ethernetCablePlugged" id="ethernetCablePlugged" v-model="DigitalHeaderTroubleshoot.ethernetCablePlugged" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('ethernetCablePlugged') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="powerButtonGlowing">The power button on the screen is glowing (red, or blue)</label>
            <select class="form-control" name="powerButtonGlowing" id="powerButtonGlowing" v-model="DigitalHeaderTroubleshoot.powerButtonGlowing" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('powerButtonGlowing') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="screenBlack">Screen is black</label>
            <select class="form-control" name="screenBlack" id="screenBlack" v-model="DigitalHeaderTroubleshoot.screenBlack" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('screenBlack') }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="screenPurple">Screen is purple with numbers</label>
            <select class="form-control" name="screenPurple" id="screenPurple" v-model="DigitalHeaderTroubleshoot.screenPurple" v-validate="'required'" data-vv-validate-on="blur">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('screenPurple') }}</span>
            </div>
          </div>

          <div class="form-group" v-if="DigitalHeaderTroubleshoot.screenPurple==='true'">
            <label for="screenPurpleNumbers">Type the numbers on the screen</label>
            <input class="form-control" name="screenPurpleNumbers" id="screenPurpleNumbers" v-model="DigitalHeaderTroubleshoot.screenPurpleNumbers" v-validate="'required'" data-vv-validate-on="blur">
            <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
              <span>{{ vErrors.first('screenPurpleNumbers') }}</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="notes">Notes</label>
          <textarea class="form-control"
                    id="notes"
                    v-model="DigitalHeaderTroubleshoot.notes"
                    name="notes"
                    rows="3">
          </textarea>
        </div>

        <div class="text-center">
          <base-button :disabled="disableSubmitButton" type="primary" @click="digitalHeaderTroubleshootSend" size='md' class="my-4">Submit</base-button>
        </div>
      </form>
    </div>
  </div>

</template>
<script>
import jobActionFormMixin from './../views/mixins/jobActionFormMixin'
import jobActionsMixin from './../views/mixins/jobActionsMixin'
import standsMixin from './../views/mixins/standsMixin'
import jobsMixin from './../views/mixins/jobsMixin'
import signatures from './Signatures'
import camera from './Camera'
export default {
  data () {
    return {
      showPreloader: false,
      showCamera: null,
      showSignature: false,
      images: [],
      signatures: [],
      photoType: null,
      jobAction: null,
      showErrorPictures: false,
      DigitalHeaderTroubleshoot: {
        isScreenWorking: null,
        surgeProtectorPlugged: null,
        isSurgeProtector: null,
        surgeProtectorSwitchLit: null,
        cordsConnected: null,
        routerScreenPlugged: null,
        ethernetCordConnected: null,
        greenPlugConnected: null,
        routerConnected: null,
        lightsSolid: null,
        antennasTight: null,
        barsTablet: null,
        ethernetCablePlugged: null,
        powerButtonGlowing: null,
        screenBlack: null,
        screenPurple: null,
        screenPurpleNumbers: null,
        pictures: [],
        notes: ''
      }
    }
  },
  props: {
    disableSubmitButton: {
      type: Boolean,
      default: false,
      description: 'Disable submit button'
    }
  },
  methods: {
    digitalHeaderTroubleshootSend () {
      this.$validator.validateAll({
        isScreenWorking: this.DigitalHeaderTroubleshoot.isScreenWorking,
        surgeProtectorPlugged: this.DigitalHeaderTroubleshoot.surgeProtectorPlugged,
        isSurgeProtector: this.DigitalHeaderTroubleshoot.isSurgeProtector,
        surgeProtectorSwitchLit: this.DigitalHeaderTroubleshoot.surgeProtectorSwitchLit,
        cordsConnected: this.DigitalHeaderTroubleshoot.cordsConnected,
        routerScreenPlugged: this.DigitalHeaderTroubleshoot.routerScreenPlugged,
        ethernetCordConnected: this.DigitalHeaderTroubleshoot.ethernetCordConnected,
        greenPlugConnected: this.DigitalHeaderTroubleshoot.greenPlugConnected,
        routerConnected: this.DigitalHeaderTroubleshoot.routerConnected,
        lightsSolid: this.DigitalHeaderTroubleshoot.lightsSolid,
        antennasTight: this.DigitalHeaderTroubleshoot.antennasTight,
        barsTablet: this.DigitalHeaderTroubleshoot.barsTablet,
        ethernetCablePlugged: this.DigitalHeaderTroubleshoot.ethernetCablePlugged,
        powerButtonGlowing: this.DigitalHeaderTroubleshoot.powerButtonGlowing,
        screenBlack: this.DigitalHeaderTroubleshoot.screenBlack,
        screenPurple: this.DigitalHeaderTroubleshoot.screenPurple,
        screenPurpleNumbers: this.DigitalHeaderTroubleshoot.screenPurpleNumbers
      }).then(result => {
        if (result) {
          if (!this.DigitalHeaderTroubleshoot.pictures.length) {
            this.showErrorPictures = true
            return
          }
          this.$emit('digitalHeaderTroubleshootFormDataSend', this.DigitalHeaderTroubleshoot)
        }
      })
    }
  },
  mixins: [jobActionFormMixin, jobActionsMixin, jobsMixin, standsMixin],
  components: {
    camera,
    signatures
  }
}
</script>
